/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useRouter } from "next/router";
import React from "react";
import { notSelect } from "../../../styles/general";
import { ContactTab } from "./ContactsDetails";

const Container = styled.div`
  display: flex;
  position: relative;
`;

interface TitleProps {
  selected: boolean;
}

const Tab = styled.button<TitleProps>`
  border-radius: 5px 5px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  padding: 12px 22px;
  ${notSelect}
  cursor: pointer;
  color: #333333;
  background-color: #ebebeb;
  border: 1px solid #ededed;
  border-bottom: 0px;

  ${(props) =>
    props.selected &&
    css`
      color: #fb972e;
      background-color: white;
      margin-bottom: -1px;
      font-weight: 600;
    `};

  margin-right: 10px;
`;

const waitingForDesign = css`
  cursor: default;
  opacity: 0.4;
`;

interface Props {
  selected: ContactTab;
  handleSelected: (vle: ContactTab) => void;
}

export default function Header(props: Props): JSX.Element {
  const { selected, handleSelected } = props;
  const router = useRouter();

  return (
    <Container>
      <Tab
        selected={selected === ContactTab.EMAILS}
        onClick={() => handleSelected(ContactTab.EMAILS)}
      >
        Emails
      </Tab>
      <Tab
        selected={selected === ContactTab.TAGS}
        onClick={() => handleSelected(ContactTab.TAGS)}
      >
        Tags
      </Tab>
      <Tab
        selected={selected === ContactTab.WEBFORMS}
        onClick={() => handleSelected(ContactTab.WEBFORMS)}
      >
        Webforms
      </Tab>
      <Tab
        selected={selected === ContactTab.CAMPAIGNS}
        onClick={() => handleSelected(ContactTab.CAMPAIGNS)}
      >
        Campaigns
      </Tab>
      {!router.pathname.includes("contacts/details") && (
        <Tab
          selected={selected === ContactTab.NOTES}
          onClick={() => handleSelected(ContactTab.NOTES)}
        >
          Notes
        </Tab>
      )}
    </Container>
  );
}
